@let loading = $loading | async;
@if (filteredSports.length === 0 && !loading) {
  <app-alert
    [config]="{
      title: 'No Sports Listings',
      subtitle: 'Check back later for updated sports events.',
      type: 'info',
    }" />
}
<app-sports-loader [show]="loading" />
@if (filteredSports.length > 0 && !loading) {
  <ul class="sports-list">
    @for (item of filteredSports; track item.id) {
      <li>
        <a
          [routerLink]="[
            '/app/main',
            {
              outlets: {
                navigation: [item.type.toLowerCase(), item.id],
              },
            },
          ]"
          class="sport-item"
          routerLinkActive="active">
          <div class="item-left">
            <mat-icon class="sport-ico">{{ getSportIcon(item?.name) }}</mat-icon>
            <span class="sport-name">{{ item?.name }}</span>
          </div>
          <div class="item-right">
            @if (item.inPlayCount > 0) {
              <span class="live-pill">LIVE</span>
            }
            <mat-icon class="chevron-ico">chevron_right</mat-icon>
          </div>
        </a>
      </li>
    }
  </ul>
}
